/**
 * @file ホーム画面に追加した状態 (PWA) で、配信済みの新しいバージョンを取り直す。
 *
 * @what: Service Worker が登録されていれば解除し、Cache Storage を空にし、いま開いている
 *   アドレスをキャッシュを迂回して取り直してから、画面を読み込み直す。
 * @why: index.html だけは内容ごとに変わる名前で配られないため、端末の HTTP キャッシュに
 *   残った古いものを読み続けることがある。ホーム画面から開く形では再読み込みの入口が画面に
 *   無く、利用者が自力で新しいバージョンへ移れない。※なぜなら標準のアドレスバーと
 *   再読み込みのボタンが出ないためである。
 * @failure: 解除も削除も取り直しも、失敗したらその段だけ飛ばして読み込み直しまで進む。
 *   ここで止めると「押しても何も起きない」状態になり、古いままで取り残されるためである。
 */

/** いま開いている画面を、端末に残ったキャッシュを避けて読み込み直す。 */
export async function reloadLatestApp(): Promise<void> {
  try {
    if ("serviceWorker" in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((r) => r.unregister()));
    }
  } catch {
    // 解除できなくても、あとの段は試す価値がある
  }

  try {
    if ("caches" in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    }
  } catch {
    // 同上
  }

  try {
    // 取り直した結果は使わない。HTTP キャッシュの中身を新しいものへ置き換えるために呼ぶ。
    await fetch(window.location.href, { cache: "reload", credentials: "same-origin" });
  } catch {
    // 圏外や失敗のときは、そのまま読み込み直して既存の経路に任せる
  }

  window.location.reload();
}
